module.exports = "<div class=\"not-found\"><h4 class=\"not-found__h\">404: Page not found</h4><a class=\"not-found__a\" href=\"javascript:history.back()\" target=\"_self\">Go back</a></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/common/templates/404.jade
// module id = 285
// module chunks = 0